export const loginForm = {
  email: {
    type: 'input',
    label: 'Email Address or Phone',
    value: '',
    config: {
      placeholder: 'Your Email or Phone',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  password: {
    type: 'input',
    label: 'Password',
    value: '',
    config: {
      type: 'password',
      placeholder: 'Your password',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};

export const passwordResetForm = {
  email: {
    type: 'input',
    label: 'Email Address',
    value: '',
    config: {
      placeholder: 'Your Email Address',
    },
    validation: {
      required: true,
      isEmail: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};


export const setPasswordForm = {
  new_password1: {
    type: 'input',
    label: 'New Password',
    value: '',
    config: {
      type: 'password',
      placeholder: 'Enter new password',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  new_password2: {
    type: 'input',
    label: 'Repeat same password',
    value: '',
    config: {
      type: 'password',
      placeholder: 'Repeat same password',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};



// WEBPACK FOOTER //
// ./src/auth/forms.js